/** Registers the static-file worker. Dev builds have none, so there is nothing to register. */
export function registerServiceWorker(): void {
  if (import.meta.env.DEV || !('serviceWorker' in navigator)) return;
  navigator.serviceWorker.register('/sw.js').catch((error) => {
    console.warn('service worker registration failed', error);
  });
}
